// extracted by mini-css-extract-plugin
export default {"root":"granularity_selector-module___root___c7fc113e","multiToggleContainer":"granularity_selector-module___multiToggleContainer___aaa02826"};